import {SpineButton} from '@fantasmagames/core/src/display/SpineButton';
import {ButtonState} from '@fantasmagames/core/src/display/Button';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {SpineUtils} from '@fantasmagames/core/src/spine/SpineUtils';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';

interface LocalesMap {
	[state: number]: string;
}

interface ButtonSlotsMap {
	[state: number]: string;
}

export class LocalizedSpineButton extends SpineButton {

	protected _locales: LocalesMap = {};
	protected _slots: ButtonSlotsMap = {};

	protected _spineUtils: SpineUtils;
	protected _resources: ResourcesLoader;

	constructor(callback: Function, spineUtils: SpineUtils, resources: ResourcesLoader) {
		super(callback);

		this._spineUtils = spineUtils;
		this._resources = resources;
	}

	public setupLocales(upLocale: string, downLocale: string, overLocale: string, disabledLocale: string): void {
		this._locales[ButtonState.UP] = upLocale;
		this._locales[ButtonState.DOWN] = downLocale ? downLocale : upLocale;
		this._locales[ButtonState.OVER] = overLocale ? overLocale : upLocale;
		this._locales[ButtonState.DISABLED] = disabledLocale ? disabledLocale : upLocale;
	}

	public setupButtonSlots(upSlotName: string, downSlotName: string, overSlotName: string, disabledSlotName: string): void {
		this._slots[ButtonState.UP] = upSlotName;
		this._slots[ButtonState.DOWN] = downSlotName ? downSlotName : upSlotName;
		this._slots[ButtonState.OVER] = overSlotName ? overSlotName : upSlotName;
		this._slots[ButtonState.DISABLED] = disabledSlotName ? disabledSlotName : upSlotName;
	}

	protected updateFrame(): void {
		if (this._animation[this._state]) {
			this.cleanFrame();
			this._spineAnimation = new SpineAnimation(this._spine, this._animation[this._state], this._animationLoop[this._state], true);
			this._spineUtils.replaceElementInSpineAnimation(
				this._spineAnimation,
				this._slots[this._state],
				new PIXI.Sprite(this._resources.getLocaleTextImage(this._locales[this._state])),
			);

			this._updateManager.add(this._spineAnimation);
			this._spineAnimation.start();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/LocalizedSpineButton.ts